import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getMessaging } from 'firebase/messaging';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Firebase configuration
// Note: These values are safe to be public - security comes from Firestore rules
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyB9cmPTYy1qIi6Y1WrNT4iz3qE_iB6OWpM",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "servesync-834ed.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "servesync-834ed",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "servesync-834ed.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "90755437730",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:90755437730:web:bd44f59eb5008cfe5933f",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-9TM8THPV9Y"
};

// Check if Firebase is configured
const isFirebaseConfigured = () => {
  return (
    firebaseConfig.apiKey &&
    firebaseConfig.apiKey !== 'your-api-key-here' &&
    firebaseConfig.projectId &&
    firebaseConfig.projectId !== 'your-project-id'
  );
};

// Initialize Firebase only if configured
let app;
let auth;
let db;
let storage;
let functions;
let messaging = null;
let analytics = null;

if (isFirebaseConfigured()) {
  try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app, 'servesyncmain');
    storage = getStorage(app);
    functions = getFunctions(app);
    // Messaging only works in browser contexts with service worker support
    if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
      messaging = getMessaging(app);
    }
    // Analytics only works in browser environments
    if (typeof window !== 'undefined') {
      isSupported().then(yes => {
        if (yes) analytics = getAnalytics(app);
      });
    }
    console.log('✅ Firebase initialized successfully');
  } catch (error) {
    console.error('❌ Firebase initialization error:', error);
    console.warn('⚠️ Running in demo mode without Firebase');
  }
} else {
  console.warn('⚠️ Firebase not configured. Please update .env.local with your Firebase credentials.');
  console.warn('📝 The app will run in demo mode. Authentication features will not work.');
}

export { auth, db, storage, functions, messaging, analytics };
export default app;
